import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SUPERGET, SUPERPOST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchDataComp = createAsyncThunk(
  "CompanyDetail/fetchDataComp",
  async (token, { rejectWithValue }) => {

    try {
      const result = await SUPERGET(`/company/gcbvtkn/${token}`);
      return result;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const CompanyDetailSlice = createSlice({
  name: "CompanyDetail",
  initialState: {
    cmpdetail: {},
    status: "idle",
    error: null,
  },
  reducers: {
    removeCompanyDetail: (state, action) => {
      return state = {
        result: {},
        status: "idle",
        error: null,
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataComp.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDataComp.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cmpdetail = action?.payload?.data ? action?.payload?.data : {};
      })
      .addCase(fetchDataComp.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { removeCompanyDetail } = CompanyDetailSlice.actions;

export default CompanyDetailSlice.reducer;
